(function() {
    'use strict';

    angular.module('app.paquetes', []);
})();
